import { FC, RefObject, useRef } from 'react'
import { ImageType } from 'react-images-uploading'
import {
  ATTACHMENT_DESCRIPTION_TYPE,
  ATTACHMENT_EXTRAFIELD,
  MEDIA_DATA_TYPE,
  SOCIAL_NETWORK
} from '../../../../../models/post'
import { TMediaCallbacks } from '../../../../../pages/CreatePost'

import {
  TChangeAttachmentExtrafieldPayload,
  TExtendedPostAttachment,
  TRemoveAttachmentPayload
} from '../../../../../store/managePost/newTypes'
import GeneralForm from '../../../../Form'
import TextAreaInput from '../../../../UI/Inputs/TextAreaInput'
import UploadImage from '../../../../UploadPostImages'

import TrashIcon from '../../../../../components/UI/Icons/Trash'
import { OriginalSocialIcons } from '../../../../UI/Icons/socials'
import { TAccountLogo } from '../../../../../selectors/ProjectSelector'

type LinkCarouselItemProps = {
  attachment: TExtendedPostAttachment
  refMediaCallbaks: RefObject<TMediaCallbacks>
  restrictions: any
  setExtraField: (data: TChangeAttachmentExtrafieldPayload) => void
  addImageToLinksToStore: (data: ImageType) => void
  deattachAttachment: (data: TRemoveAttachmentPayload) => void
  removeImageFromLinkIntoStore: (id: TRemoveAttachmentPayload) => void
  logo: TAccountLogo
  isEditable: boolean
}

const LinkCarouselItem: FC<LinkCarouselItemProps> = ({
  refMediaCallbaks,
  attachment,
  logo,
  setExtraField,
  deattachAttachment,
  addImageToLinksToStore,
  removeImageFromLinkIntoStore,
  isEditable,
  restrictions
}) => {
  const formRef = useRef<any>(null)
  const attachmentIds = { id: attachment.id, temporaryId: attachment.temporaryId }

  const onBlurInput = (field: ATTACHMENT_EXTRAFIELD) => {
    if (formRef.current) {
      let onChangePayload: TChangeAttachmentExtrafieldPayload = {
        value: formRef.current.values[field],
        field,
        ...attachmentIds
      }

      if (!!attachment?.id) onChangePayload.id = attachment.id
      else if (!!attachment?.temporaryId) onChangePayload.temporaryId = attachment.temporaryId

      setExtraField(onChangePayload)
    }
  }

  const setUpForm = {
    initialValues: {
      link: attachment?.extra_fields?.link || '',
      name: attachment?.extra_fields?.name || '',
      description: attachment?.extra_fields?.description || ''
    },
    innerRef: formRef,
    validation: 'link',
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: true,
    onSubmit: () => {}
  }

  const manageMediaProps = {
    attachments: attachment.object_data ? [attachment] : [],
    isEditable,
    addMediaToPost: addImageToLinksToStore,
    refMediaCallbaks,
    restrictions,
    removeMediaFromStore: removeImageFromLinkIntoStore,
    firstImageHeight: 100
  }

  const isRootLink = attachment.description === ATTACHMENT_DESCRIPTION_TYPE.LINK

  return (
    <div
      key={`carousel-item-${'id' + attachment.id || 'tId' + attachment.temporaryId}`}
      className='facebook-link-carousel__item'
    >
      <div className='facebook-link-carousel__item__image-wrapper'>
        {!isRootLink && isEditable && !manageMediaProps.attachments.length && (
          <div
            className='facebook-link-carousel__item__image-wrapper__remove'
            onClick={() => deattachAttachment(attachmentIds)}
          >
            <TrashIcon />
          </div>
        )}
        {!isRootLink ? (
          <UploadImage {...manageMediaProps} />
        ) : (
          <div className='facebook-link-carousel__item__image-wrapper__root'>
            {logo.original ? (
              <img
                src={logo.original}
                alt='any'
                className='facebook-link-carousel__item__image-wrapper__root__img'
              />
            ) : (
              logo.default
            )}
          </div>
        )}
      </div>
      <div className='facebook-link-carousel__item__data-wrapper'>
        <GeneralForm {...setUpForm}>
          {!isRootLink && (
            <>
              <div className='facebook-link-carousel__item__data-wrapper__link-name'>
                <TextAreaInput
                  name={ATTACHMENT_EXTRAFIELD.NAME}
                  placeholder='Name'
                  disabled={!isEditable}
                  customOnBlur={() => onBlurInput(ATTACHMENT_EXTRAFIELD.NAME)}
                />
              </div>
              <div className='facebook-link-carousel__item__data-wrapper__link-description'>
                <TextAreaInput
                  name={ATTACHMENT_EXTRAFIELD.DESCRIPTION}
                  placeholder='Description'
                  disabled={!isEditable}
                  customOnBlur={() => onBlurInput(ATTACHMENT_EXTRAFIELD.DESCRIPTION)}
                />
              </div>
            </>
          )}
          <div className='facebook-link-carousel__item__data-wrapper__link'>
            <TextAreaInput
              name={ATTACHMENT_EXTRAFIELD.LINK}
              placeholder='Link'
              disabled={!isEditable}
              customOnBlur={() => onBlurInput(ATTACHMENT_EXTRAFIELD.LINK)}
            />
          </div>
        </GeneralForm>
      </div>
    </div>
  )
}

export default LinkCarouselItem
